export default (theme) => ({
    messageContainer: {
        top: "35%",
        left: 0,
        right: 0,
        position: "absolute",
        textAlign: "center",
        padding: "25% 0",
    },
    listItem: {
        borderBottom: 1,
        borderColor: theme.palette.border.darkBorder,
        padding: 4,
    },
    spinnerContainer: {
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        width: "100%",
    },
    loadingText: {
        display: "flex",
        alignItems: "center",
        paddingLeft: "1rem",
    },
    alertWrapper: {
        display: "flex",
        flexFlow: "column",
        padding: 2,
    },
    card: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        maxWidth: 375,
        width: "90%",
        mx: "auto",
        my: 1,
        boxShadow: 3,
        borderRadius: 2,
    },
    listLayout: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(min(275px, 100%), 3fr))",
        gap: 2,
    },
    margin: {
        marginTop: `${theme.spacing(2)}`,
        padding: `0 ${theme.spacing(2)} `,
    },
    leftLayout: {
        width: "20%", // Fixed to 30% width
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        "& svg": {
            fontSize: 25,
        },
    },
    rightLayout: {
        width: { xs: "100%", sm: "80%" },
        borderLeft: `1px solid ${theme.palette.border.mediumBorder}`,
        "div.MuiTypography-root": {
            py: 1,
            borderBottom: `1px solid ${theme.palette.border.mediumBorder}`,
            textTransform: "capitalize",
        },
    },
    closeAlert: {
        width: "100%",
        marginTop: 2,
    },
});
